export function useLocalization() {
  const getLocalized = (item, field) => {
    const lang = localStorage.getItem("language") || "en"; // Default to 'en' if no language is stored
    return lang === "kh" ? item[`${field}_kh`] : item[`${field}_en`];
  };

  return {
    getLocalized,
  };
}

export function useSmartERP() {
  const getGlobalized = (item, field) => {
    const lang = localStorage.getItem("language") || "en"; // Default to 'en' if no language is stored
    if (lang === "kh" && item[`${field}_kh`]) {
      return item[`${field}_kh`];
    }
    return item[`${field}`] || "No data available"; // Fallback text if field is missing
  };

  return {
    getGlobalized,
  };
}
